module.exports = __webpack_public_path__ + "static/img/__7711.071e24a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__7711.jpg
// module id = PxLb
// module chunks = 0